import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

export default function GraphicDesign() {
  const designs = [
    {
      id: 1,
      title: 'Event Poster Design',
      description: 'Professional event promotion poster with bold typography',
      image: 'https://public.readdy.ai/ai/img_res/2e8a4074d96f56b026df4b97e86704df.jpg',
      category: 'Posters'
    },
    {
      id: 2,
      title: 'Business Flyer',
      description: 'Corporate business flyer with clean design',
      image: 'https://readdy.ai/api/search-image?query=professional%20business%20flyer%20design%20corporate%20style%20clean%20layout%20modern%20typography%20elegant%20color%20scheme%20marketing%20material%20contemporary%20graphic%20design%20minimalist%20aesthetic%20clean%20simple%20background&width=600&height=800&seq=design-flyer-1&orientation=portrait',
      category: 'Flyers'
    },
    {
      id: 3,
      title: 'Social Media Graphics',
      description: 'Engaging Instagram post design',
      image: 'https://readdy.ai/api/search-image?query=modern%20social%20media%20post%20design%20for%20instagram%20vibrant%20colors%20trendy%20layout%20engaging%20visual%20content%20contemporary%20graphic%20design%20eye%20catching%20composition%20clean%20simple%20background&width=800&height=800&seq=design-social-1&orientation=squarish',
      category: 'Social Media'
    },
    {
      id: 4,
      title: 'Anniversary Graphics',
      description: 'Elegant anniversary celebration design',
      image: 'https://readdy.ai/api/search-image?query=elegant%20anniversary%20celebration%20graphic%20design%20sophisticated%20layout%20gold%20accents%20luxury%20style%20professional%20design%20beautiful%20typography%20festive%20composition%20clean%20simple%20background&width=800&height=800&seq=design-anniversary-1&orientation=squarish',
      category: 'Special Events'
    },
    {
      id: 5,
      title: 'Brand Identity Package',
      description: 'Complete brand identity with logo and guidelines',
      image: 'https://readdy.ai/api/search-image?query=professional%20brand%20identity%20design%20package%20with%20logo%20business%20cards%20letterhead%20modern%20corporate%20style%20clean%20layout%20elegant%20typography%20cohesive%20visual%20system%20clean%20simple%20background&width=800&height=600&seq=design-brand-1&orientation=landscape',
      category: 'Branding'
    },
    {
      id: 6,
      title: 'Product Advertisement',
      description: 'Eye-catching product ad design',
      image: 'https://readdy.ai/api/search-image?query=modern%20product%20advertisement%20design%20eye%20catching%20layout%20vibrant%20colors%20professional%20marketing%20material%20contemporary%20graphic%20design%20compelling%20visual%20composition%20clean%20simple%20background&width=600&height=800&seq=design-ad-1&orientation=portrait',
      category: 'Advertising'
    },
    {
      id: 7,
      title: 'Church Event Flyer',
      description: 'Spiritual event promotion design',
      image: 'https://readdy.ai/api/search-image?query=elegant%20church%20event%20flyer%20design%20spiritual%20theme%20inspiring%20layout%20warm%20colors%20professional%20religious%20graphic%20design%20uplifting%20composition%20beautiful%20typography%20clean%20simple%20background&width=600&height=800&seq=design-church-1&orientation=portrait',
      category: 'Events'
    },
    {
      id: 8,
      title: 'Birthday Celebration',
      description: 'Festive birthday party design',
      image: 'https://readdy.ai/api/search-image?query=colorful%20festive%20birthday%20celebration%20graphic%20design%20party%20theme%20vibrant%20colors%20fun%20layout%20joyful%20composition%20modern%20design%20style%20celebratory%20aesthetic%20clean%20simple%20background&width=800&height=800&seq=design-birthday-1&orientation=squarish',
      category: 'Celebrations'
    },
    {
      id: 9,
      title: 'Business Card Design',
      description: 'Professional business card layout',
      image: 'https://readdy.ai/api/search-image?query=modern%20professional%20business%20card%20design%20elegant%20layout%20clean%20typography%20corporate%20style%20minimalist%20aesthetic%20contemporary%20graphic%20design%20sophisticated%20composition%20clean%20simple%20background&width=800&height=600&seq=design-card-1&orientation=landscape',
      category: 'Branding'
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-r from-purple-500 to-pink-600 text-white">
        <div className="container mx-auto px-6 text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">Graphic Design Services</h1>
          <p className="text-xl md:text-2xl max-w-3xl mx-auto">
            Professional designs that capture attention and communicate your message effectively
          </p>
        </div>
      </section>

      {/* Design Process */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-4">Our Design Process</h2>
            <p className="text-xl text-gray-600">From concept to final delivery</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-5 gap-6">
            <div className="text-center">
              <div className="w-16 h-16 bg-purple-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-chat-3-line text-3xl text-white"></i>
              </div>
              <h4 className="text-lg font-bold mb-2">Brief</h4>
              <p className="text-gray-600 text-sm">Understanding your needs and goals</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-pink-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-lightbulb-line text-3xl text-white"></i>
              </div>
              <h4 className="text-lg font-bold mb-2">Concept</h4>
              <p className="text-gray-600 text-sm">Developing creative ideas</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-teal-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-pencil-ruler-2-line text-3xl text-white"></i>
              </div>
              <h4 className="text-lg font-bold mb-2">Design</h4>
              <p className="text-gray-600 text-sm">Creating the visual solution</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-blue-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-refresh-line text-3xl text-white"></i>
              </div>
              <h4 className="text-lg font-bold mb-2">Revisions</h4>
              <p className="text-gray-600 text-sm">Refining based on feedback</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-check-line text-3xl text-white"></i>
              </div>
              <h4 className="text-lg font-bold mb-2">Delivery</h4>
              <p className="text-gray-600 text-sm">Final files in all formats</p>
            </div>
          </div>
        </div>
      </section>

      {/* Design Gallery */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-4">Design Portfolio</h2>
            <p className="text-xl text-gray-600">A showcase of our creative work</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {designs.map(design => (
              <div key={design.id} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all group">
                <div className="overflow-hidden">
                  <img 
                    src={design.image}
                    alt={design.title}
                    className="w-full h-96 object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="p-6">
                  <div className="inline-block bg-purple-100 text-purple-600 px-3 py-1 rounded-full text-sm font-semibold mb-3">
                    {design.category}
                  </div>
                  <h3 className="text-xl font-bold mb-2">{design.title}</h3>
                  <p className="text-gray-600">{design.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Services Offered */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-4">What We Design</h2>
            <p className="text-xl text-gray-600">Comprehensive graphic design solutions</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-xl p-6">
              <div className="w-12 h-12 bg-purple-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-file-list-3-line text-2xl text-white"></i>
              </div>
              <h4 className="text-xl font-bold mb-2">Posters & Flyers</h4>
              <p className="text-gray-700">Eye-catching promotional materials for events, businesses, and campaigns</p>
            </div>

            <div className="bg-gradient-to-br from-pink-50 to-pink-100 rounded-xl p-6">
              <div className="w-12 h-12 bg-pink-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-instagram-line text-2xl text-white"></i>
              </div>
              <h4 className="text-xl font-bold mb-2">Social Media Graphics</h4>
              <p className="text-gray-700">Engaging content for Instagram, Facebook, Twitter, and other platforms</p>
            </div>

            <div className="bg-gradient-to-br from-teal-50 to-teal-100 rounded-xl p-6">
              <div className="w-12 h-12 bg-teal-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-briefcase-line text-2xl text-white"></i>
              </div>
              <h4 className="text-xl font-bold mb-2">Business Materials</h4>
              <p className="text-gray-700">Business cards, letterheads, brochures, and corporate documents</p>
            </div>

            <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-6">
              <div className="w-12 h-12 bg-blue-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-megaphone-line text-2xl text-white"></i>
              </div>
              <h4 className="text-xl font-bold mb-2">Advertisements</h4>
              <p className="text-gray-700">Print and digital ads that drive results and capture attention</p>
            </div>

            <div className="bg-gradient-to-br from-red-50 to-red-100 rounded-xl p-6">
              <div className="w-12 h-12 bg-red-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-calendar-event-line text-2xl text-white"></i>
              </div>
              <h4 className="text-xl font-bold mb-2">Event Graphics</h4>
              <p className="text-gray-700">Wedding invitations, birthday cards, anniversary designs, and more</p>
            </div>

            <div className="bg-gradient-to-br from-yellow-50 to-yellow-100 rounded-xl p-6">
              <div className="w-12 h-12 bg-yellow-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-star-line text-2xl text-white"></i>
              </div>
              <h4 className="text-xl font-bold mb-2">Brand Identity</h4>
              <p className="text-gray-700">Logo design, brand guidelines, and complete visual identity systems</p>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-4">Design Pricing</h2>
            <p className="text-xl text-gray-600">Affordable rates for quality designs</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <h3 className="text-2xl font-bold mb-4">Basic</h3>
              <div className="mb-6">
                <span className="text-4xl font-bold text-purple-600">₦5,000</span>
                <span className="text-gray-600"> / design</span>
              </div>
              <ul className="space-y-3 mb-8">
                <li className="flex items-start">
                  <i className="ri-check-line text-green-500 mt-1 mr-2"></i>
                  <span className="text-gray-700">Single design concept</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-green-500 mt-1 mr-2"></i>
                  <span className="text-gray-700">2 revisions</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-green-500 mt-1 mr-2"></i>
                  <span className="text-gray-700">High-resolution files</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-green-500 mt-1 mr-2"></i>
                  <span className="text-gray-700">2-3 days delivery</span>
                </li>
              </ul>
              <Link to="/contact" className="whitespace-nowrap block text-center bg-purple-500 hover:bg-purple-600 text-white px-6 py-3 rounded-full font-semibold transition-all cursor-pointer">
                Get Started
              </Link>
            </div>

            <div className="bg-gradient-to-br from-purple-500 to-pink-600 rounded-2xl p-8 shadow-2xl transform scale-105">
              <div className="bg-white text-purple-600 px-4 py-1 rounded-full text-sm font-bold inline-block mb-4">
                POPULAR
              </div>
              <h3 className="text-2xl font-bold mb-4 text-white">Standard</h3>
              <div className="mb-6">
                <span className="text-4xl font-bold text-white">₦10,000</span>
                <span className="text-white/80"> / design</span>
              </div>
              <ul className="space-y-3 mb-8 text-white">
                <li className="flex items-start">
                  <i className="ri-check-line mt-1 mr-2"></i>
                  <span>2 design concepts</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line mt-1 mr-2"></i>
                  <span>Unlimited revisions</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line mt-1 mr-2"></i>
                  <span>All file formats</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line mt-1 mr-2"></i>
                  <span>1-2 days delivery</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line mt-1 mr-2"></i>
                  <span>Source files included</span>
                </li>
              </ul>
              <Link to="/contact" className="whitespace-nowrap block text-center bg-white hover:bg-gray-100 text-purple-600 px-6 py-3 rounded-full font-semibold transition-all cursor-pointer">
                Get Started
              </Link>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <h3 className="text-2xl font-bold mb-4">Premium</h3>
              <div className="mb-6">
                <span className="text-4xl font-bold text-purple-600">₦20,000+</span>
                <span className="text-gray-600"> / project</span>
              </div>
              <ul className="space-y-3 mb-8">
                <li className="flex items-start">
                  <i className="ri-check-line text-green-500 mt-1 mr-2"></i>
                  <span className="text-gray-700">Multiple design concepts</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-green-500 mt-1 mr-2"></i>
                  <span className="text-gray-700">Unlimited revisions</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-green-500 mt-1 mr-2"></i>
                  <span className="text-gray-700">Brand guidelines</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-green-500 mt-1 mr-2"></i>
                  <span className="text-gray-700">Priority support</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-green-500 mt-1 mr-2"></i>
                  <span className="text-gray-700">Rush delivery available</span>
                </li>
              </ul>
              <Link to="/contact" className="whitespace-nowrap block text-center bg-purple-500 hover:bg-purple-600 text-white px-6 py-3 rounded-full font-semibold transition-all cursor-pointer">
                Get Started
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-teal-500 to-blue-600">
        <div className="container mx-auto px-6 text-center text-white">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">Need a Custom Design?</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Let's create stunning visuals that elevate your brand and message
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link 
              to="/contact" 
              className="whitespace-nowrap bg-white hover:bg-gray-100 text-teal-600 px-8 py-4 rounded-full text-lg font-semibold transition-all cursor-pointer shadow-lg"
            >
              Request a Design
            </Link>
            <a 
              href="tel:08162117807" 
              className="whitespace-nowrap bg-transparent hover:bg-white/10 text-white border-2 border-white px-8 py-4 rounded-full text-lg font-semibold transition-all cursor-pointer"
            >
              Call: 08162117807
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}